import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { InspectionDocumentService } from "../../services/inspection-document-service/inspection-document.service";
import { AddDocumentDialogData } from "./add-document-dialog-data";
import { FileUploadOptions } from "@cotecna/file-management";
import {
  ALLOWED_CONTENT_TYPES_200MB,
  ALLOWED_CONTENT_TYPES_1GB,
} from "../../constants/constants";

const fileUploadOptions = <FileUploadOptions>{
  allowedExtensions: [
    ".doc",
    ".docx",
    ".xls",
    ".xlsx",
    ".ppt",
    ".pptx",
    ".accdb",
    ".pub",
    ".xps",
    ".pdf",
    ".jpg",
    ".jpeg",
    ".png",
    ".raw",
    ".mpg",
    ".mpg2",
    ".mpeg",
    ".mpe",
    ".mp4",
    ".avi",
    ".wmv",
    ".mov",
    ".rar",
    ".zip",
  ],
  chipsVisible: true,
  customPlaceholder: "Drag files or click to upload",
  disabled: false,
  tableMode: false,
};

@Component({
    selector: "im-add-document",
    templateUrl: "./add-document.component.html",
    styleUrls: ["./add-document.component.scss"],
    standalone: false
})
export class AddDocumentComponent {
  constructor(
    private dialogRef: MatDialogRef<AddDocumentComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: AddDocumentDialogData,
    private uploadService: InspectionDocumentService,
  ) {}

  files: File[] = [];

  public readyLoading = true;
  public showContentTypeWarning = false;
  public showUploadDocumentError = false;

  submitButtonDisabled = true;

  fileUploadOptions = fileUploadOptions;

  onFilesSelected(files: File[]) {
    this.files = files;
    this.showUploadDocumentError = false;
    this.showContentTypeWarning = false;
    this.submitButtonDisabled = files.length === 0;
    for (let file of this.files) {
      if (file.type != "") {
        if (
          !ALLOWED_CONTENT_TYPES_200MB.includes(file.type) &&
          !ALLOWED_CONTENT_TYPES_1GB.includes(file.type)
        ) {
          this.showContentTypeWarning = true;
          this.submitButtonDisabled = true;
        } else if (
          ALLOWED_CONTENT_TYPES_200MB.includes(file.type) &&
          file.size > 1024 * 1024 * 200
        ) {
          this.showContentTypeWarning = true;
          this.submitButtonDisabled = true;
        } else if (
          ALLOWED_CONTENT_TYPES_1GB.includes(file.type) &&
          file.size > 1024 * 1024 * 1000
        ) {
          this.showContentTypeWarning = true;
          this.submitButtonDisabled = true;
        }
      } else {
        if (!file.name.endsWith(".xps")) {
          this.showContentTypeWarning = true;
          this.submitButtonDisabled = true;
        }
        if (file.name.endsWith(".xps") && file.size > 1024 * 1024 * 200) {
          this.showContentTypeWarning = true;
          this.submitButtonDisabled = true;
        }
      }
    }
  }

  async submit() {
    this.readyLoading = false;
    this.dialogRef.disableClose = true;
    try {
      await this.uploadService.uploadDocuments(
        this.dialogData.inspectionId,
        this.files,
      );
      this.readyLoading = true;
      this.dialogRef.close(true);
    } catch (error) {
      this.readyLoading = true;
      this.showUploadDocumentError = true;
    }
  }

  cancel() {
    if (this.readyLoading) this.dialogRef.close();
  }
}
